<template>
  <div class="ai-ppt">
    <div class="ppt-workspace-toolbar">
      <div class="ppt-header">
        <div class="step-title">PPT制作流程：</div>
        <div class="step-item" v-for="item in stepList" :key="item.index">
          <span class="index">{{ item.index }}</span>
          {{ item.name }}
        </div>
      </div>
      <div class="ppt-history-heading" v-if="step === 1 && hasHistory">
        历史记录
      </div>
    </div>
    <PPTOption
      v-if="step === 1"
      :user-info="userInfo"
      :is-authenticated="isAuthenticated"
      @getUserStatus="$emit('getUserStatus')"
      @history-state="setHistoryState"
      @confirmOpt="showSelectTemplate"
    />
    <PPTOutline
      :pptConfig="pptConfig"
      @goback="goback"
      @showPop="showPop"
      v-if="step === 2"
    />
    <PPTTemplate
      ref="pptTemplate"
      btnText="生成PPT大纲"
      @commit="selectTemplate"
    />
    <PackagePop ref="packagePop" />
  </div>
</template>
<script>
import PPTOption from "./PPTOption";
import PPTOutline from "./PPTOutline";
import PPTTemplate from "./PPTTemplate";
import PackagePop from "./PackagePop";
export default {
  // 组件名称
  name: "AiPPT",
  props: {
    userInfo: {
      type: String,
      default: "",
    },
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PPTOption,
    PPTOutline,
    PPTTemplate,
    PackagePop,
  },
  // 变量声明
  data() {
    return {
      step: 1,
      pptConfig: {},
      hasHistory: false,
      stepList: [
        { index: 1, name: "输入文本" },
        { index: 2, name: "挑选ppt模版" },
        { index: 3, name: "生成大纲" },
        { index: 4, name: "自动生成ppt" },
        { index: 5, name: "导出下载" },
      ],
    };
  },
  watch: {},
  // 实例初始化之后,进行数据侦听和事件/侦听器的配置之前同步调用
  beforeCreate() {},
  // 实例创建，挂载阶段未开始，可进行数据初始化
  created() {},
  mounted() {},
  destroyed() {},
  // 方法
  methods: {
    setHistoryState(hasHistory) {
      this.hasHistory = hasHistory;
    },
    showPop() {
      this.step = 1;
      this.$refs.packagePop.open();
    },
    goback() {
      this.step = 1;
    },
    showSelectTemplate(option) {
      this.$refs.pptTemplate.show(option);
    },
    selectTemplate(config) {
      this.pptConfig = config;
      this.step = 2;
    },
  },
};
</script>
<style lang="less" scoped>
.ai-ppt {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: visible;
}

.ppt-workspace-toolbar {
  position: absolute;
  top: -60px;
  right: 0;
  left: 0;
  z-index: 13;
  display: flex;
  height: 60px;

  .ppt-header {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    min-width: 0;
    height: 60px;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    background: var(--primary-light);

    .step-title {
      flex: 0 0 auto;
      margin-left: 35px;
      font-weight: 600;
      font-size: 18px;
      color: var(--primary-dark);
      line-height: 60px;
    }

    .step-item {
      flex: 0 0 auto;
      margin-left: 18px;
      font-size: 16px;
      color: var(--foreground-secondary);
      line-height: 60px;
      transition: color .15s;

      .index {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: var(--primary);
        font-size: 12px;
        color: #ffffff;
        line-height: 20px;
        text-align: center;
      }
    }
  }

  .ppt-history-heading {
    flex: 0 0 340px;
    height: 60px;
    padding: 0 16px;
    box-sizing: border-box;
    background: var(--bg-card);
    border-left: 1px solid var(--border);
    border-bottom: 1px solid var(--border-light);
    font-weight: 600;
    font-size: 16px;
    color: var(--foreground-secondary);
    line-height: 60px;
  }
}

.ai-ppt /deep/ .ppt-option,
.ai-ppt /deep/ .ppt-outline {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.ai-ppt /deep/ .ppt-option {
  flex: 1 1 auto;
  height: 100%;
  min-height: 0;
  margin-left: 0;
}

.ai-ppt /deep/ .ppt-container {
  min-width: 0;
  min-height: 0;
}

.ai-ppt /deep/ .ppt-history {
  flex: 0 0 340px;
  height: 100%;
  min-height: 0;
}

/* AI PPT 移动工作台：流程栏回到文档流，子步骤占满可用宽度。 */
@media (max-width: 768px) {
  .ai-ppt {
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    overflow: hidden;
  }

  .ppt-workspace-toolbar {
    position: static;
    flex: 0 0 auto;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    min-width: 0;

    .ppt-header {
      display: flex;
      flex: 0 0 100%;
      flex-wrap: wrap;
      align-items: center;
      gap: 4px 10px;
      width: 100%;
      height: auto;
      min-width: 0;
      padding: 8px 12px;
      overflow: visible;
      box-sizing: border-box;
      white-space: normal;

      .step-title {
        flex: 0 0 100%;
        margin: 0;
        font-size: 15px;
        line-height: 22px;
      }

      .step-item {
        margin: 0;
        font-size: 12px;
        line-height: 26px;

        .index {
          width: 18px;
          height: 18px;
          line-height: 18px;
        }
      }
    }

    .ppt-history-heading {
      display: none;
    }
  }

  .ai-ppt /deep/ .ppt-option,
  .ai-ppt /deep/ .ppt-outline {
    flex: 1 1 auto;
    width: 100%;
    height: auto;
    min-width: 0;
    min-height: 0;
  }

  .ai-ppt /deep/ .ppt-history {
    flex: 0 0 240px !important;
    width: 100% !important;
    height: 240px !important;
    min-height: 0;
  }
}
</style>
